export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/gaming_videos.1e30084.svg";